// Copyright (c) 2016 Deere & Company

export default [
    {
        displayName: 'PIN',
        path: ['pin']
    },
    {
        displayName: 'RESPONSIBLE_DEALER',
        path: ['dealer', 'name']
    },
    {
        displayName: 'COMPLETION_STATUS',
        path: ['pipCompletionStatus', 'value']
    }
];



// WEBPACK FOOTER //
// ./src/pip/pip-details/state/affected-pin-sort-options.js